<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Master Field</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="fields.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="fields.description"
                v-validate="'required'"
                data-vv-as="Fields Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Level:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="fields.level"
                :vs-value="'account'"
                class="mr-4"
                vs-name="level"
                >Account</vs-radio
              >
              <vs-radio
                v-model="fields.level"
                :vs-value="'contact'"
                class="mr-4"
                vs-name="level"
                >Contact</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('level')"
              >{{ errors.first("level") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sales Developer Access:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="fields.sales_developer_access"
                :vs-value="'yes'"
                class="mr-4"
                vs-name="sales_developer_access"
                >Yes</vs-radio
              >
              <vs-radio
                v-model="fields.sales_developer_access"
                :vs-value="'no'"
                class="mr-4"
                vs-name="sales_developer_access"
                >No</vs-radio
              >
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('sales_developer_access')"
              >{{ errors.first("sales_developer_access") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="fields.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div
            class="vx-row mb-6"
            v-if="
              (fields.type && fields.type.value == 'dropdown') ||
                (fields.type && fields.type.value == 'checkbox') ||
                (fields.type && fields.type.value == 'choose_one')
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="chooseExistingList"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              (fields.type && fields.type.value == 'dropdown') ||
                (fields.type && fields.type.value == 'checkbox') ||
                (fields.type && fields.type.value == 'choose_one')
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Value:</span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="fields.value"
                data-vv-as="Value"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addValue" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="chooseExistingList">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-row vs-w="12" class="mb-5">
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
                  <FieldsAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox"
                    :list="searchExistingFieldLists"
                    :searchOn="'master-field'"
                    @event-name="handleChildEvent"
                  ></FieldsAutocomplete>

                  <!-- <v-select
                    class="mb-4"
                    label="name"
                    name="existing_list"
                    :options="existing_fields_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="fields.existing_list"
                  /> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="4"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>

              <div class="vx-col sm:w-1/2 w-full">
                <span v-for="elv in existing_list_values" class="p-2">
                  <vs-input
                    class="w-full"
                    name="existing_list_value"
                    v-model="elv.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeExistingListValues(elv)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <template v-if="fields.values && fields.values.length > 0">
              <div class="vx-col sm:w-1/5 w-full"></div>
            </template>

            <div class="vx-col sm:w-1/4 w-full">
              <template v-for="(v, index) in fields.values">
                <span :key="index" class="p-2">
                  <vs-input
                    class="w-full"
                    name="field_new_values"
                    v-model="v.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeSelectedValue(v)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </template>
            </div>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'masterFields'" 
            ref="masterFields"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleMasterFieldsManagement from "@/store/fields-management/master-fields-management/moduleMasterFieldsManagement.js";
import FieldsAutocomplete from "@/components/autocomplete/FieldsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      companySearchComponentKey: 0,
      please_choose_options: null,
      chooseExistingList: false,
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          width: 400,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Value",
          field: "values",
          width: 550,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Sales Developer Access",
          field: "sales_developer_access",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      allFields: [],
      abilities: null,
      existing_list_values: [],
      existing_fields_list: [],
      fields: {
        values: [],
        name: null,
        description: null,
        level:'account',
        type: null,
        value: null,
        sales_developer_access: "yes",
        existing_list: null
      },
      types: [
        {
          name: "Text",
          value: "text"
        },
        {
          name: "Number",
          value: "number"
        },
        {
          name: "Textarea",
          value: "textarea"
        },
        {
          name: "Date",
          value: "date"
        },
        {
          name: "DateTime",
          value: "datetime"
        },
        {
          name: "Checkbox",
          value: "checkbox"
        },
        {
          name: "Dropdown",
          value: "dropdown"
        },
        {
          name: "Choose One",
          value: "choose_one"
        }
      ]
    };
  },
  components: {
    "v-select": vSelect,
    moduleMasterFieldsManagement,
    DataGrid,
    FieldsAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.getExistingFieldLists();
  },
  watch: {
    "fields.type.value": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    "fields.type": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    // "fields.existing_list": function(val) {
    //   // if (val) {
    //   //   let filtered_value = this.existing_fields_list.filter(ele => {
    //   //     return ele.field_id == val.field_id;
    //   //   });
    //   //   if (filtered_value) {
    //   //     let lists = filtered_value[0];
    //   //     this.existing_list_values = JSON.parse(lists.values);
    //   //   }

    //   //   console.log(this.existing_list_values);
    //   // }
    // },
    chooseExistingList: function(val) {
      if (val) {
        this.chooseExistingList = true;
        // this.existing_list_values = null
        // // let filtered_value = this.existing_fields_list.filter(ele => {
        // //   return ele.field_id == val.field_id;
        // // });
        // let filtered_value = this.existing_fields_list
        // if (filtered_value) {
        //   let lists = filtered_value[0];
        //   this.existing_list_values = JSON.parse(lists.values);
        // }

        // console.log(this.existing_list_values);
      } else {
        this.existing_list_values = [];
      }
    }
  },
  methods: {
    searchExistingFieldLists(inputValue) {
      let search_from = "master_field";
      return this.$store
        .dispatch("MasterFieldsManagement/searchExistingFieldLists", {
          search_from: search_from,
          inputValue: inputValue
        })
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              data = JSON.parse(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].field_id,
                  name: data[property].name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let selected_field = moduleMasterFieldsManagement.state.selected_fields;
      console.log("SELECTED" , selected_field)
      if (selected_field) {
        let filtered_value = this.existing_fields_list.filter(ele => {
          return ele.field_id == selected_field.id;
        });
        if (filtered_value) {
          let lists = filtered_value[0];
          this.existing_list_values = JSON.parse(lists.values);
        }

        console.log(this.existing_list_values);
      }
    },
    removeSelectedValue(value) {
      this.fields.values = this.fields.values.filter(item => {
        return item != value;
      });
    },
    removeExistingListValues(value) {
      this.existing_list_values = this.existing_list_values.filter(item => {
        return item != value;
      });
    },
    addValue() {
      if (this.fields.value && !this.fields.values.includes(this.fields.value))
        this.fields.values.push({
          value: this.fields.value
        });
      this.fields.value = null;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "MasterFieldsManagement/getAllMasterFields",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.masterFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.masterFields.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
            this.$router.replace("/login");
    }
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addFields();
        }
      });
    },
    addFields() {
      if (
        this.fields.type.value == "checkbox" ||
        this.fields.type.value == "dropdown" ||
        this.fields.type.value == "choose_one"
      ) {
        if (
          this.fields.values.length == 0 &&
          this.existing_list_values.length == 0
        ) {
          this.please_choose_options =
            "Atleast one options is required for " +
            this.fields.type.value +
            " list.";
          return false;
        }
      }

      let joined_values = [];
      joined_values = this.fields.values.concat(this.existing_list_values);
      joined_values = joined_values.filter(function(ele) {
        return ele != null;
      });
      this.fields.values = joined_values;

      this.$store
        .dispatch("MasterFieldsManagement/addFields", this.fields)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Master Fields Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Fields Added",
              text: "The master fields was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/master-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getExistingFieldLists() {
      this.$store
        .dispatch(
          "MasterFieldsManagement/getExistingFieldLists",
          "master_field"
        )
        .then(res => {
          console.log("LISTS", JSON.parse(res.data));
          let result = JSON.parse(res.data);
          if (result) {
            this.existing_fields_list = result;
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
